module.exports = __webpack_public_path__ + "static/media/securityAndCompliance-min.1d7fc5eb.jpg";